export default "__VITE_ASSET__CSJzJ2Sl__"